import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';
import { IEntityStore } from './integration/common'
import { defaultCatch } from './utils';
import { addOrUpdateOrRemove } from './services/storeHelper';
import { post, put, remove } from '../fetch-interceptor';
import { EntityType } from '../entities/common';
import { SourceType } from './ExternalEpmConnectStore';

export type ExtensionsState = IEntityStore<ExtensionInfo[]>;

type UpdatedExtensionAction = { type: 'UPDATE_EXTENSION', addOrUpdate?: ExtensionInfo[], remove?: string[];}
type DeletedExtensionAction = { type: 'DELETED_EXTENSION', extensions: ExtensionInfo[] }
type ProcessingExtensionAction = { type: 'PROCESSING_EXTENSIONS' }

type KnownAction = UpdatedExtensionAction | DeletedExtensionAction | ProcessingExtensionAction;

const initialState: ExtensionsState = {
    isLoading: false,
    isProcessing: false,
    entities: [],
    error: null
};

type BaseExtensionInfo = { name: string, description?: string, url: string, type: ExtensionType, location: ExtensionLocation, size?: ExtensionEmbededContentSize };
export type ExtensionInfo = BaseExtensionInfo & { id: string };
export type SaveExtensionInfo = BaseExtensionInfo & { id?: string};
export enum ExtensionLocation {
    QuickStart = 1,
    PortfoliosPageActions = 2,
    PortfoliosPageViews = 3,
    PortfolioDashboardHeaderAction = 4,
    PortfolioDashboardActionItems = 5,
    PortfolioDashboardKeyDates = 6,
    PortfolioDashboardKeyDecisions = 7,
    PortfolioDashboardProgramsProjects = 8,
    PortfolioDashboardResourcePlan = 9,
    PortfolioDashboardRisks = 10,
    ProgramsPageActions = 11,
    ProgramsPageViews = 12,
    ProgramDashboardHeaderAction = 13,
    ProgramDashboardActionItems = 14,
    ProgramDashboardKeyDates = 15,
    ProgramDashboardKeyDecisions = 16,
    ProgramDashboardProjects = 17,
    ProgramDashboardResourcePlan = 18,
    ProgramDashboardRisks = 19,
    ProjectsPageActions = 20,
    ProjectsPageViews = 21,
    ProjectDashboardHeaderAction = 22,
    ProjectDashboardActionItems = 23,
    ProjectDashboardChangeRequests = 24,
    ProjectDashboardDependencies = 25,
    ProjectDashboardIssues = 26,
    ProjectDashboardInvoices = 27,
    ProjectDashboardIterations = 28,
    ProjectDashboardKeyDates = 29,
    ProjectDashboardKeyDecisions = 30,
    ProjectDashboardLessonsLearned = 31,
    ProjectDashboardPurchaseOrders = 32,
    ProjectDashboardResourcePlan = 33,
    ProjectDashboardRisks = 34,
    ProjectDashboardSteeringCommittee = 35,
    TasksPageTasks = 36,
    BusinessChallengesPageActions = 37,
    BusinessChallengesPageViews = 38,
    BusinessChallengeDashboardHeaderAction = 39,
    BusinessChallengeDashboardIdeasSection = 40,
    IdeaDashboardHeaderAction = 41,
    IdeaDashboardResourcePlan = 42,
    IdeaDashboardRisks = 43,
    TasksPageTasksEntityAction = 44,
    VstsTasksPageTasks = 45,
    VstsTasksPageTasksEntityAction = 46,
    JiraTasksPageTasks = 47,
    JiraTasksPageTasksEntityAction = 48,
    PlannerTasksPageTasks = 49,
    PlannerTasksPageTasksEntityAction = 50,
    SpoTasksPageTasks = 51,
    SpoTasksPageTasksEntityAction = 52,
    MondayComTasksPageTasks = 53,
    MondayComTasksPageTasksEntityAction = 54,
    SmartsheetTasksPageTasks = 55,
    SmartsheetTasksPageTasksEntityAction = 56,
    P4WTasksPageTasks = 57,
    P4WTasksPageTasksEntityAction = 58,
    MPPFileTasksPageTasks = 59,
    MPPFileTasksPageTasksEntityAction = 60,
    TasksPageTasksEditPanel = 61,
    VstsTasksPageTasksEditPanel = 62,
    JiraTasksPageTasksEditPanel = 63,
    PlannerTasksPageTasksEditPanel = 64,
    SpoTasksPageTasksEditPanel = 65,
    MondayComTasksPageTasksEditPanel = 66,
    SmartsheetTasksPageTasksEditPanel = 67,
    P4WTasksPageTasksEditPanel = 68,
    MPPFileTasksPageTasksEditPanel = 69,
    PortfolioDashboardActionItemsEditPanel = 70,
    PortfolioDashboardKeyDatesEditPanel = 71,
    PortfolioDashboardKeyDecisionsEditPanel = 72,
    PortfolioDashboardRisksEditPanel = 73,
    ProgramDashboardActionItemsEditPanel = 74,
    ProgramDashboardKeyDatesEditPanel = 75,
    ProgramDashboardKeyDecisionsEditPanel = 76,
    ProgramDashboardRisksEditPanel = 77,
    ProjectDashboardActionItemsEditPanel = 78,
    ProjectDashboardKeyDatesEditPanel = 79,
    ProjectDashboardKeyDecisionsEditPanel = 80,
    ProjectDashboardRisksEditPanel = 81,
    ProjectDashboardSteeringCommitteeEditPanel = 82,
    ProjectDashboardLessonsLearnedEditPanel = 83,
    ProjectDashboardPurchaseOrdersEditPanel = 84,
    ProjectDashboardIterationsEditPanel = 85,
    ProjectDashboardChangeRequestsEditPanel = 86,
    ProjectDashboardDependenciesEditPanel = 87,
    ProjectDashboardIssuesEditPanel = 88,
    ProjectDashboardInvoicesEditPanel = 89,
    IdeaDashboardRisksEditPanel = 90,
    PortfolioDashboardActionItemsCreatePanel = 91,
    PortfolioDashboardKeyDatesCreatePanel = 92,
    PortfolioDashboardKeyDecisionsCreatePanel = 93,
    PortfolioDashboardRisksCreatePanel = 94,
    ProgramDashboardActionItemsCreatePanel = 95,
    ProgramDashboardKeyDatesCreatePanel = 96,
    ProgramDashboardKeyDecisionsCreatePanel = 97,
    ProgramDashboardRisksCreatePanel = 98,
    ProjectDashboardActionItemsCreatePanel = 99,
    ProjectDashboardKeyDatesCreatePanel = 100,
    ProjectDashboardKeyDecisionsCreatePanel = 101,
    ProjectDashboardRisksCreatePanel = 102,
    ProjectDashboardSteeringCommitteeCreatePanel = 103,
    ProjectDashboardLessonsLearnedCreatePanel = 104,
    ProjectDashboardPurchaseOrdersCreatePanel = 105,
    ProjectDashboardIterationsCreatePanel = 106,
    ProjectDashboardChangeRequestsCreatePanel = 107,
    ProjectDashboardDependenciesCreatePanel = 108,
    ProjectDashboardIssuesCreatePanel = 109,
    ProjectDashboardInvoicesCreatePanel = 110,
    IdeaDashboardRisksCreatePanel = 111,
    TasksPageTasksCreatePanel = 112,
    ResourcesPageActions = 113,
    ResourcesPageViews = 114,
    ResourceDashboardActions = 115,
    ResourceDashboardCalendarExceptionsActions = 116,
    ProjectDashboardDeliverables = 117,
    ProjectDashboardDeliverablesEditPanel = 118,
    ProjectDashboardDeliverablesCreatePanel = 119,
    TasksPageTasksViews = 120,
    VstsTasksPageTasksViews = 121,
    JiraTasksPageTasksViews = 122,
    PlannerTasksPageTasksViews = 123,
    SpoTasksPageTasksViews = 124,
    MondayComTasksPageTasksViews = 125,
    SmartsheetTasksPageTasksViews = 126,
    P4WTasksPageTasksViews = 127,
    MPPFileTasksPageTasksViews = 128,
}

export const findExtension = (extensions: ExtensionsState, entityType: EntityType, location: ExtensionPageLocation, subEntityType?: EntityType, sourceType?: SourceType): ExtensionInfo[] => {
    const locationToSearch = (subEntityType ?? entityType) === EntityType.Task && sourceType !== undefined
        ? EntityTypeToLocationMap[subEntityType ?? entityType]?.[sourceType]?.[location]
        : subEntityType
            ? EntityTypeToLocationMap[entityType]?.[subEntityType]?.[location]
            : EntityTypeToLocationMap[entityType]?.[location];

    return extensions.entities.filter(_ => _.location === locationToSearch);
}

export enum ExtensionPageLocation {
    Actions,
    Views,
    EntityAction,
    EntityEditPanel,
    EntityCreatePanel
}

export const EditPanelLocations = [
    ExtensionLocation.PortfolioDashboardActionItemsEditPanel,
    ExtensionLocation.PortfolioDashboardKeyDatesEditPanel,
    ExtensionLocation.PortfolioDashboardKeyDecisionsEditPanel,
    ExtensionLocation.PortfolioDashboardRisksEditPanel,
    ExtensionLocation.ProgramDashboardActionItemsEditPanel,
    ExtensionLocation.ProgramDashboardKeyDatesEditPanel,
    ExtensionLocation.ProgramDashboardKeyDecisionsEditPanel,
    ExtensionLocation.ProgramDashboardRisksEditPanel,
    ExtensionLocation.ProjectDashboardActionItemsEditPanel,
    ExtensionLocation.ProjectDashboardKeyDatesEditPanel,
    ExtensionLocation.ProjectDashboardKeyDecisionsEditPanel,
    ExtensionLocation.ProjectDashboardRisksEditPanel,
    ExtensionLocation.ProjectDashboardSteeringCommitteeEditPanel,
    ExtensionLocation.ProjectDashboardLessonsLearnedEditPanel,
    ExtensionLocation.ProjectDashboardPurchaseOrdersEditPanel,
    ExtensionLocation.ProjectDashboardIterationsEditPanel,
    ExtensionLocation.ProjectDashboardChangeRequestsEditPanel,
    ExtensionLocation.ProjectDashboardDependenciesEditPanel,
    ExtensionLocation.ProjectDashboardIssuesEditPanel,
    ExtensionLocation.ProjectDashboardInvoicesEditPanel,
    ExtensionLocation.IdeaDashboardRisksEditPanel,
    ExtensionLocation.TasksPageTasksEditPanel,
    ExtensionLocation.VstsTasksPageTasksEditPanel,
    ExtensionLocation.JiraTasksPageTasksEditPanel,
    ExtensionLocation.PlannerTasksPageTasksEditPanel,
    ExtensionLocation.SpoTasksPageTasksEditPanel,
    ExtensionLocation.MondayComTasksPageTasksEditPanel,
    ExtensionLocation.SmartsheetTasksPageTasksEditPanel,
    ExtensionLocation.P4WTasksPageTasksEditPanel,
    ExtensionLocation.MPPFileTasksPageTasksEditPanel,
    ExtensionLocation.ProjectDashboardDeliverablesEditPanel
]

export const CreatePanelLocations = [
    ExtensionLocation.PortfolioDashboardActionItemsCreatePanel,
    ExtensionLocation.PortfolioDashboardKeyDatesCreatePanel,
    ExtensionLocation.PortfolioDashboardKeyDecisionsCreatePanel,
    ExtensionLocation.PortfolioDashboardRisksCreatePanel,
    ExtensionLocation.ProgramDashboardActionItemsCreatePanel,
    ExtensionLocation.ProgramDashboardKeyDatesCreatePanel,
    ExtensionLocation.ProgramDashboardKeyDecisionsCreatePanel,
    ExtensionLocation.ProgramDashboardRisksCreatePanel,
    ExtensionLocation.ProjectDashboardActionItemsCreatePanel,
    ExtensionLocation.ProjectDashboardKeyDatesCreatePanel,
    ExtensionLocation.ProjectDashboardKeyDecisionsCreatePanel,
    ExtensionLocation.ProjectDashboardRisksCreatePanel,
    ExtensionLocation.ProjectDashboardSteeringCommitteeCreatePanel,
    ExtensionLocation.ProjectDashboardLessonsLearnedCreatePanel,
    ExtensionLocation.ProjectDashboardPurchaseOrdersCreatePanel,
    ExtensionLocation.ProjectDashboardIterationsCreatePanel,
    ExtensionLocation.ProjectDashboardChangeRequestsCreatePanel,
    ExtensionLocation.ProjectDashboardDependenciesCreatePanel,
    ExtensionLocation.ProjectDashboardIssuesCreatePanel,
    ExtensionLocation.ProjectDashboardInvoicesCreatePanel,
    ExtensionLocation.IdeaDashboardRisksCreatePanel,
    ExtensionLocation.TasksPageTasksCreatePanel,
    ExtensionLocation.ProjectDashboardDeliverablesCreatePanel
]

export const EntityTypeToLocationMap = {
    [EntityType.Portfolio]: {
        [ExtensionPageLocation.Actions]: ExtensionLocation.PortfoliosPageActions,
        [ExtensionPageLocation.Views]: ExtensionLocation.PortfoliosPageViews,
        [ExtensionPageLocation.EntityAction]: ExtensionLocation.PortfolioDashboardHeaderAction,
        [EntityType.Program]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PortfolioDashboardProgramsProjects,
        },
        [EntityType.Resource]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PortfolioDashboardResourcePlan,
        },
        [EntityType.ActionItem]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PortfolioDashboardActionItems,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.PortfolioDashboardActionItemsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.PortfolioDashboardActionItemsCreatePanel,
        },
        [EntityType.KeyDate]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PortfolioDashboardKeyDates,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.PortfolioDashboardKeyDatesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.PortfolioDashboardKeyDatesCreatePanel,
        },
        [EntityType.KeyDecision]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PortfolioDashboardKeyDecisions,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.PortfolioDashboardKeyDecisionsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.PortfolioDashboardKeyDecisionsCreatePanel,
        },
        [EntityType.Risk]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PortfolioDashboardRisks,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.PortfolioDashboardRisksEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.PortfolioDashboardRisksCreatePanel,
        },
    },
    [EntityType.Program]: {
        [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramsPageActions,
        [ExtensionPageLocation.Views]: ExtensionLocation.ProgramsPageViews,
        [ExtensionPageLocation.EntityAction]: ExtensionLocation.ProgramDashboardHeaderAction,
        [EntityType.Project]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramDashboardProjects,
        },
        [EntityType.Resource]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramDashboardResourcePlan,
        },
        [EntityType.ActionItem]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramDashboardActionItems,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProgramDashboardActionItemsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProgramDashboardActionItemsCreatePanel,
        },
        [EntityType.KeyDate]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramDashboardKeyDates,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProgramDashboardKeyDatesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProgramDashboardKeyDatesCreatePanel,
        },
        [EntityType.KeyDecision]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramDashboardKeyDecisions,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProgramDashboardKeyDecisionsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProgramDashboardKeyDecisionsCreatePanel,
        },
        [EntityType.Risk]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProgramDashboardRisks,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProgramDashboardRisksEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProgramDashboardRisksCreatePanel,
        }
    },
    [EntityType.Project]: {
        [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectsPageActions,
        [ExtensionPageLocation.Views]: ExtensionLocation.ProjectsPageViews,
        [ExtensionPageLocation.EntityAction]: ExtensionLocation.ProjectDashboardHeaderAction,
        [EntityType.Resource]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardResourcePlan,
        },
        [EntityType.ActionItem]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardActionItems,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardActionItemsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardActionItemsCreatePanel,
        },
        [EntityType.ChangeRequest]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardChangeRequests,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardChangeRequestsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardChangeRequestsCreatePanel,
        },
        [EntityType.Dependency]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardDependencies,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardDependenciesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardDependenciesCreatePanel,
        },
        [EntityType.Issue]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardIssues,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardIssuesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardIssuesCreatePanel,
        },
        [EntityType.Invoice]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardInvoices,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardInvoicesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardInvoicesCreatePanel,
        },
        [EntityType.Iteration]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardIterations,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardIterationsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardIterationsCreatePanel,
        },
        [EntityType.KeyDate]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardKeyDates,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardKeyDatesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardKeyDatesCreatePanel,
        },
        [EntityType.KeyDecision]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardKeyDecisions,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardKeyDecisionsEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardKeyDecisionsCreatePanel,
        },
        [EntityType.LessonLearned]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardLessonsLearned,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardLessonsLearnedEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardLessonsLearnedCreatePanel,
        },
        [EntityType.PurchaseOrder]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardPurchaseOrders,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardPurchaseOrdersEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardPurchaseOrdersCreatePanel,
        },
        [EntityType.Risk]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardRisks,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardRisksEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardRisksCreatePanel,
        },
        [EntityType.SteeringCommittee]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardSteeringCommittee,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardSteeringCommitteeEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardSteeringCommitteeCreatePanel,
        },
        [EntityType.Deliverable]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ProjectDashboardDeliverables,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.ProjectDashboardDeliverablesEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.ProjectDashboardDeliverablesCreatePanel,
        }
    },
    [EntityType.Task]: {
        [SourceType.Ppmx]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.TasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.TasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.TasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.TasksPageTasksEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.TasksPageTasksCreatePanel,
        },
        [SourceType.VSTS]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.VstsTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.VstsTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.VstsTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.VstsTasksPageTasksEditPanel,
        },
        [SourceType.Jira]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.JiraTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.JiraTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.JiraTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.JiraTasksPageTasksEditPanel,
        },
        [SourceType.O365Planner]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.PlannerTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.PlannerTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.PlannerTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.PlannerTasksPageTasksEditPanel,
        },
        [SourceType.Spo]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.SpoTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.SpoTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.SpoTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.SpoTasksPageTasksEditPanel,
        },
        [SourceType.MondayCom]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.MondayComTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.MondayComTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.MondayComTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.MondayComTasksPageTasksEditPanel,
        },
        [SourceType.Smartsheet]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.SmartsheetTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.SmartsheetTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.SmartsheetTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.SmartsheetTasksPageTasksEditPanel,
        },
        [SourceType.P4W]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.P4WTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.P4WTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.P4WTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.P4WTasksPageTasksEditPanel,
        },
        [SourceType.MPPFile]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.MPPFileTasksPageTasks,
            [ExtensionPageLocation.Views]: ExtensionLocation.MPPFileTasksPageTasksViews,
            [ExtensionPageLocation.EntityAction]: ExtensionLocation.MPPFileTasksPageTasksEntityAction,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.MPPFileTasksPageTasksEditPanel,
        }
    },
    [EntityType.Challenge]: {
        [ExtensionPageLocation.Actions]: ExtensionLocation.BusinessChallengesPageActions,
        [ExtensionPageLocation.Views]: ExtensionLocation.BusinessChallengesPageViews,
        [ExtensionPageLocation.EntityAction]: ExtensionLocation.BusinessChallengeDashboardHeaderAction,
        [EntityType.Idea]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.BusinessChallengeDashboardIdeasSection
        }
    },
    [EntityType.Idea]: {
        [ExtensionPageLocation.EntityAction]: ExtensionLocation.IdeaDashboardHeaderAction,
        [EntityType.Resource]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.IdeaDashboardResourcePlan,
        },
        [EntityType.Risk]: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.IdeaDashboardRisks,
            [ExtensionPageLocation.EntityEditPanel]: ExtensionLocation.IdeaDashboardRisksEditPanel,
            [ExtensionPageLocation.EntityCreatePanel]: ExtensionLocation.IdeaDashboardRisksCreatePanel,
        }
    },
    [EntityType.Resource]: {
        [ExtensionPageLocation.Actions]: ExtensionLocation.ResourcesPageActions,
        [ExtensionPageLocation.Views]: ExtensionLocation.ResourcesPageViews,
        [ExtensionPageLocation.EntityAction]: ExtensionLocation.ResourceDashboardActions,
        CalendarException: {
            [ExtensionPageLocation.Actions]: ExtensionLocation.ResourceDashboardCalendarExceptionsActions,
        }
    }
};

export enum ExtensionType {
    EmbeddedContent = 0,
    TriggerAction = 1,
    OpenNewTab = 2
}

export enum ExtensionEmbededContentSize {
    Normal = 0,
    Small = 1,
    Large = 2,
    FullScreen = 3,
    Canvas = 4
}

export const actionCreators = {
    saveExtension: (extension: SaveExtensionInfo): AppThunkAction<KnownAction> => (dispatch, getState) =>{
        (extension.id ? put<ExtensionInfo>(`api/extensions`, extension) : post<ExtensionInfo>(`api/extensions`, extension))
            .then(data => dispatch({ type: 'UPDATE_EXTENSION', addOrUpdate: [data] }))
            .catch(defaultCatch(dispatch));
        dispatch(({ type: 'PROCESSING_EXTENSIONS'}));
    },
    removeExtension: (ids: string[]): AppThunkAction<KnownAction> => (dispatch, getState) =>{
        remove<never>(`api/extensions`, { ids })
            .then(_ => dispatch({ type: 'UPDATE_EXTENSION', remove: ids }))
            .catch(defaultCatch(dispatch));
        dispatch(({ type: 'PROCESSING_EXTENSIONS'}));
    }
};

export const reducer: Reducer<ExtensionsState> = (state = initialState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "UPDATE_EXTENSION":
            return {
                ...state,
                ...initialState,
                entities: addOrUpdateOrRemove(state.entities, action.addOrUpdate, action.remove)
            };         
        case "PROCESSING_EXTENSIONS":
            return {
                ...state,
                isProcessing: true
            };
        default:
            return state;
    }
};